import { SyslogSettingsFormState } from '.'

export const syslogIsDifferent = (
  original: SyslogSettingsFormState,
  current: SyslogSettingsFormState
) => {
  return (
    original.port !== current.port ||
    original.host !== current.host ||
    original.protocol !== current.protocol ||
    original.facilityCode !== current.facilityCode ||
    original.severityByAttackStatus.EXPLOITED !==
      current.severityByAttackStatus.EXPLOITED ||
    original.severityByAttackStatus.SUSPICIOUS !==
      current.severityByAttackStatus.SUSPICIOUS ||
    original.severityByAttackStatus.BLOCKED !==
      current.severityByAttackStatus.BLOCKED ||
    original.severityByAttackStatus.BLOCKED_PERIMETER !==
      current.severityByAttackStatus.BLOCKED_PERIMETER ||
    original.severityByAttackStatus.PROBED !==
      current.severityByAttackStatus.PROBED
  )
}
